import { httpRequest } from "@services/http";
import { Contract } from "@models/contract.model";
import { ContractSerializer } from "@models/serializers/contractSerializer";

export interface CreateContractPayload {
  client_org_id: number;
  service_provider_org_id: number;
  name?: string | null;
  billing_method?: string | null;
  po?: string | null;
  contract_url?: string | null;
  contract_start_date?: string | null;
  contract_end_date?: string | null;
  products?: string[];
  revenue_cap?: number | null;
  max_list_size?: number | null;
  sized_by?: string | null;
  list_type?: string | null;
  /** The vertical's journey (MPN-1573). Omit to leave unchanged; null clears it. */
  journey_id?: number | null;
  is_active?: boolean;
}

export class CommandCreateContract {
  async run(payload: CreateContractPayload): Promise<Contract> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/finance/contracts/`;
    const response = await httpRequest<any>(url, {
      method: "POST",
      body: JSON.stringify(payload),
    });
    return ContractSerializer.fromJson(response);
  }
}
